var sectionsWithCTA = $('.section .block__ctaOpen');
$(sectionsWithCTA).each(function () {
    var sectionBody = $(this).closest('.section-body');

    // in each section, check if each column has one and only one CTA
    // if so, align the CTA buttons.
    let alignButtons = true;
    sectionBody.children().each(function () {
        var widgetCount = $(this).children().length;
        var ctaCount = $(this).children('.block__ctaOpen').length;
        if (widgetCount != ctaCount || ctaCount != 1)
            alignButtons = false;
    });

    if (alignButtons)
        sectionBody.addClass('all-ctas');
});